import React from 'react';

class ErrorNoPage extends React.Component {

    render() {
        return (
            <>
                <h1>Error: Unknown route</h1>
            </>
        );
    }
}

export default ErrorNoPage;
